<template>
  <b-modal
    v-model="showModal"
    ref="sheetModal"
    :title="modalTitle"
    centered
    hide-footer
    scrollable
    :size="size"
    content-class="shadow"
    :no-close-on-backdrop="restrictiveClose"
    :no-close-on-esc="restrictiveClose"
    header-bg-variant="3v3"
    header-text-variant="light"
    @hidden="modalHidden"
  >
    <component
      v-if="modalContentComponent"
      :is="modalContentComponent"
      :item-selected="item"
    />
  </b-modal>
</template>

<script>
import FarmDAPTable from "@/pages/registerPages/Management/components/FarmDAPTable.vue";
import ManualStation from "@/pages/registerPages/Management/ManualStation.vue";
import SectorEquipmentsTable from "@/pages/registerPages/Sectors/components/SectorEquipmentsTable.vue";
import GroupEquipamentsTable from "@/pages/registerPages/Users/components/GroupEquipamentsTable.vue";

export default {
  components: {
    FarmDAPTable,
    ManualStation,
    SectorEquipmentsTable,
    GroupEquipamentsTable,
  },
  props: {
    modalPrefix: {
      type: String,
      default: "",
    },
    modalSize: {
      type: String,
      default: "",
    },
    modalContentComponent: {
      type: String,
      default: "",
    },
    value: {
      required: true,
      type: Boolean,
    },
    restrictiveClose: {
      default: false,
      type: Boolean,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    size() {
      return this.modalSize;
    },
    modalTitle() {
      const itemName = this.item && this.item.NAME;

      return [this.modalPrefix, itemName].filter((val) => val).join(" ");
    },
    showModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    modalHidden() {
      // Emitir um evento para o componente pai
      this.$emit("close-action-modal");
    },
  },
};
</script>
